const {
  CREATURE_TYPE_MONSTROSITY,
  CREATURE_TYPE_SHAPESHIFTER,
  CREATURE_TYPE_YUAN_TI,
} = require('./../../../../creatureTypeIdList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  LANG_ABYSSAL,
  LANG_COMMON,
  LANG_DRACONIC,
} = require('./../../../../languageIdList')
const {
  DAMAGE_PIERCING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  SKILL_DECEPTION,
  SKILL_STEALTH,
} = require('./../../../../skillList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  SPELL_ANIMAL_FRIENDSHIP,
  SPELL_SUGGESTION,
} = require('./../../../../spellIdList')
const {
  GEAR_LONGBOW,
  GEAR_SCIMITAR,
} = require('./../../../../gearIdList')
const {
  yuantiDescriptionList,
  yuantiNoteList,
} = require('./../../../../textCommonParts')
const {
  CREATURE_YUAN_TI_MALISON_1,
  CREATURE_YUAN_TI_MALISON_2,
  CREATURE_YUAN_TI_MALISON_3,
} = require('./../../../../creatureIdList')
const {ABILITY_MAGIC_RESISTANCE} = require('./../../../../creatureAbilityList')
const {ALIGNMENT_NE} = require('./../../../../aligmentList')
const {CAST_MATERIAL} = require('./../../../../castComponentList')
const {CONDITION_POISONED} = require('./../../../../conditionList')
const {CR_3} = require('./../../../../crList')
const {GENDER_MALE} = require('./../../../../genderList')
const {PROF_NORMAL} = require('./../../../../proficiencyList')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_MEDIUM} = require('./../../../../sizeList')
const {SOURCE_MM} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')
const {TARGET_CREATURE} = require('./../../../../targetList')

module.exports = {
  name: 'Юань-ти проклинатель, вид 1',
  nameEn: 'Yuan-ti Malison, Type 1',
  id: CREATURE_YUAN_TI_MALISON_1,
  description: [
    `Проклинатель — ужасная смесь человеческих и змеиных черт. Известны три типа проклинателей, хотя и другие типы также возможны. Проклинатели формируют среднюю касту в обществе юань-ти, и охотятся со стрелами, смазанными собственным ядом. Они используют магическую силу внушения, чтобы принудить врагов сдаться.`,
    {
      header: 'Вид проклинателя',
      text: `Юань-ти может быть нескольких видов

1. [Вид 1](CREATURE:${CREATURE_YUAN_TI_MALISON_1}): Человеческое тело со змеиной головой.
2. [Вид 2](CREATURE:${CREATURE_YUAN_TI_MALISON_2}): Человеческая голова и тело со змеями вместо рук.
3. [Вид 3](CREATURE:${CREATURE_YUAN_TI_MALISON_3}): Человеческая голова и торс со змеиным телом вместо ног.`,
      source: {
        id: SOURCE_MM,
        page: 314,
      },
    },
    ...yuantiDescriptionList,
  ],
  note: yuantiNoteList,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_MONSTROSITY,
    CREATURE_TYPE_SHAPESHIFTER,
    CREATURE_TYPE_YUAN_TI,
  ],
  alignmentId: ALIGNMENT_NE,
  source: {
    id: SOURCE_MM,
    page: 314,
  },
  armor: 12,
  hp: {
    diceCount: 12,
  },
  speed: {
    [SPEED_WALK]: 30,
  },
  params: {
    [PARAM_STR]: 16,
    [PARAM_DEX]: 14,
    [PARAM_CON]: 13,
    [PARAM_INT]: 14,
    [PARAM_WIT]: 12,
    [PARAM_CHA]: 16,
  },
  skillCollection: {
    [SKILL_DECEPTION]: PROF_NORMAL,
    [SKILL_STEALTH]: PROF_NORMAL,
  },
  immunityList: [
    DAMAGE_POISON,
  ],
  immunityConditionList: [
    CONDITION_POISONED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    LANG_ABYSSAL,
    LANG_DRACONIC,
    LANG_COMMON,
  ],
  cr: CR_3,
  featureList: [
    {
      name: 'Перевёртыш',
      description: `★СУЩЕСТВО★ может действием превратиться в Среднюю змею или принять свой истинный облик. Во всех обликах ★его★ характеристики остаются теми же самыми. Всё несомое и носимое ★им★ снаряжение не превращается. ★Он★ не меняет облик, если умирает.`,
    },
    ABILITY_MAGIC_RESISTANCE,
  ],
  spellCast: {
    baseStat: PARAM_CHA,
    componentExclude: CAST_MATERIAL,
    comment: 'только в облике юань-ти',
    spellIdByCountList: [
      {
        limit: Infinity,
        list: [
          {
            id: SPELL_ANIMAL_FRIENDSHIP,
            comment: `только змеи`,
          },
        ],
      },
      {
        limit: {
          count: 3,
          period: 'день',
        },
        list: [
          SPELL_SUGGESTION,
        ],
      },
    ],
  },
  actionList: [
    {
      name: 'Мультиатака',
      comment: 'только в облике юань-ти',
      description: `★СУЩЕСТВО★ совершает две дальнобойные атаки или две рукопашные атаки, но _Укус_ может использовать только раз.`,
    },
    {
      name: 'Укус',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 5,
        range: 5,
        target: {
          count: 1,
          limit: {
            type: TARGET_CREATURE,
          },
        },
        hit: [
          {
            type: DAMAGE_PIERCING,
            diceCount: 1,
            diceType: 4,
            diceBonus: 3,
          },
          {
            type: DAMAGE_POISON,
            diceCount: 2,
            diceType: 6,
            diceBonus: 0,
          },
        ],
      },
    },
    {
      gearId: GEAR_SCIMITAR,
      comment: 'только в облике юань-ти',
    },
    {
      gearId: GEAR_LONGBOW,
      comment: 'только в облике юань-ти',
      attack: {
        hit: {
          type: DAMAGE_POISON,
          diceCount: 2,
          diceType: 6,
          diceBonus: 0,
        },
      },
    },
  ],
  genderId: GENDER_MALE,
}
